import { useState } from "react";
import Modal from "../../portal/Modal";
import useImageUrl from "../../../CustomHooks/useImageUrl";

const ImageSlider = ({
  title,
  images,
  imageSliderCurrentIndex,
  closeDialogBox,
}) => {
  const [currentIndex, setCurrentIndex] = useState(imageSliderCurrentIndex);
  const { getImageUrl } = useImageUrl();

  const prevSlide = () => {
    const newIndex = currentIndex === 0 ? images.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };

  const nextSlide = () => {
    const newIndex = currentIndex === images.length - 1 ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };

  return (
    <Modal
      onClose={closeDialogBox}
      modalWidth="max-w-xl w-11/12 z-9999 bg-white rounded py-2 px-3"
      closeIcon={true}
    >
      <h3 className="imgSliderHeading">{title}</h3>
      <div className="relative">
        {images.length > 1 && (
          <button className="left-0 prev-next-btn" onClick={prevSlide}>
            ❮
          </button>
        )}
        <div className="mx-7">
          <img
            src={getImageUrl(images[currentIndex])}
            alt={`Slide ${currentIndex}`}
            className="sliderImg"
          />
        </div>
        {images.length > 1 && (
          <button className="right-0 prev-next-btn" onClick={nextSlide}>
            ❯
          </button>
        )}
      </div>
      {images.length > 1 && (
        <h3 className="currentSliderImgInd">
          {`${currentIndex + 1}/${images.length}`}
        </h3>
      )}
    </Modal>
  );
};
export default ImageSlider;
